import { ActionTypes, CallActions } from "./../actions/index";
import { CallState } from "../states";

const getInitialState = (): CallState => {
  return {
    state: null,
    ticket: null,
    testDevicePermissionsUrl: null,
    agentVolume: 0,
    isAgentMuted: false,
    isCamOn: true,
    isMicOn: true,
    isRemoteScreenShareOn: false,
    isPopedOut: false,
    mediaAvailable: { audio: true, video: true, displayCapture: true },
  };
};

const call = (state = getInitialState(), action: ActionTypes): CallState => {
  switch (action.type) {
    case CallActions.CALL_STATE_CHANGE:
      return { ...state, state: action.payload };
    case CallActions.TICKET_CHANGE:
      return { ...state, ticket: action.payload };
    case CallActions.TEST_DEVICE_PERMISSIONS_URL_CHANGE:
      return { ...state, testDevicePermissionsUrl: action.payload };
    case CallActions.CALL_ENDED:
      return { ...getInitialState(), isPopedOut: state.isPopedOut };
    case CallActions.AGENT_MUTED:
      return { ...state, isAgentMuted: action.payload };
    case CallActions.AGENT_VOLUME_CHANGE:
      return { ...state, agentVolume: action.payload };
    case CallActions.TRACK_KIND_STATE_CHANGE:
      switch (action.payload.kind) {
        case "audio":
          return { ...state, isMicOn: action.payload.enabled };
        case "video":
          return { ...state, isCamOn: action.payload.enabled };
      }
    case CallActions.SCREEN_SHARE_AVAILABILITY_CHANGE:
      return { ...state, isRemoteScreenShareOn: action.payload };
    case CallActions.POPPED_OUT_CHANGE:
      return { ...state, isPopedOut: action.payload };
    case CallActions.MEDIA_AVAILABLE_CHANGE:
      return { ...state, mediaAvailable: action.payload };
  }
  return state;
};

export default call;
